import { get } from 'lodash-es';

import { STATUS_LOADING, STATUS_SUCCESS, STATUS_ERROR } from 'store/status';
import { GET_PROFILE, UPDATE_PROFILE, UPLOAD_AVATAR } from 'modules/dashboard/store/constants';
import { profile as initialState } from 'modules/dashboard/store/reducers/initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_PROFILE}_REQUESTED`:
    case `${UPDATE_PROFILE}_REQUESTED`: {
      return { ...state, status: STATUS_LOADING };
    }

    case `${GET_PROFILE}_SUCCEEDED`: {
      const data = get(action, ['payload', 'profile'], null);
      const url = get(action, ['payload', 'avatar'], null);

      return {
        ...state,
        status: STATUS_SUCCESS,
        data,
        avatar: {
          data: {
            ...state.avatar.data,
            url,
          },
          status: STATUS_SUCCESS,
        },
      };
    }

    case `${GET_PROFILE}_FAILED`:
    case `${UPDATE_PROFILE}_FAILED`: {
      return { ...state, status: STATUS_ERROR };
    }

    case `${UPLOAD_AVATAR}_REQUESTED`: {
      return {
        ...state,
        avatar: {
          ...state.avatar,
          status: STATUS_LOADING,
        },
      };
    }

    case `${UPLOAD_AVATAR}_FAILED`: {
      return {
        ...state,
        avatar: {
          ...state.avatar,
          status: STATUS_ERROR,
        },
      };
    }

    case `${UPLOAD_AVATAR}_SUCCEEDED`: {
      const data = get(action, 'payload', null);

      return {
        ...state,
        avatar: {
          ...state.avatar,
          data,
          status: STATUS_SUCCESS,
        },
      };
    }

    default:
      return state;
  }
};

export default reducer;
